"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle readmore element
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.readmore = {
    initialize: function () {
        'use strict';
        $('[data-readmore="true"]').each(function (index, readmore) {
            var $readmore = $(readmore), $btn;
            if ($readmore.data('readmoreButton')) {
                $btn = $('<a href="#" class="readmore-button btn">' +
                    '<span class="text">' + $readmore.data('readmoreButton') + '</span><span class="icon-toggle" aria-hidden="true"></span></a>');
            }
            else if ($readmore.data('readmoreLink')) {
                var trackingCode = '';
                // Add klick tracking link if enabled
                if ($readmore.data('readmoreLinkTracking') === true) {
                    trackingCode = 'data-track-category="' + $readmore.data('readmoreLinkTrackingSource') + '" ' +
                        'data-track-object="' + $readmore.data('readmoreLinkTrackingLabel') + '" ' +
                        'data-track-action="' + $readmore.data('readmoreLinkTrackingType') + '"';
                }
                $btn = $('<a href="#" class="readmore-link" ' + trackingCode + ' data-track-event="true">' +
                    $readmore.data('readmoreLink') + '<span class="icon-toggle" aria-hidden="true"></span></a>');
            }
            else {
                if (window.console) {
                    console.error('Readmore element given, but no readmore label assigned.');
                }
            }
            $btn.insertAfter($readmore.find('.readmore-intro'))
                .on('click', function (event) {
                event.preventDefault();
                $readmore.toggleClass('readmore-opened');
                $('.readmore .readmore-collapse').addClass('hide-in-print');
                $('.readmore-opened .readmore-collapse').removeClass('hide-in-print');
                // Remove onmousedown tracking after first click on element
                $btn.removeAttr("onmousedown");
            });
        });
    }
};
exports.default = {};
